"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Case = exports.If = exports.instance = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Basic logic components for JSX
 *
 * Note (Hubert, 2017A): it's better to write the subcomponents as functions
 *   so that they're not created if not necessary.
 *
 * Copyright (C) 2017A Noom, Inc.
 * @author Hubert OG
*/
var instance = function instance(value) {
  return _lodash["default"].isFunction(value) ? value() : value || null;
};
/**
 *  If / then / else control block.
 *
 *  Usage examples:
 *
 *  <If if={ this.displayButton() } then={ <Button/> }/>
 *
 *  <If
 *    if={ condition }
 *    then={()=>(
 *      <div> Condition is true </div>
 *    )}
 *    else={()=>(
 *      <div> Condition is false </div>
 *    )}
 *  />
 */


exports.instance = instance;

var If = function If(props) {
  return props["if"] ? instance(props.then) : instance(props["else"]);
};
/**
 *  Switch / case control block
 *
 *  Usage example:
 *
 *  <Case
 *    switch={ this.props.color }
 *    case0='GREEN' then0={()=>(
 *      <div> I see trees of green </div>
 *    )}
 *    case1='RED' then1={()=>(
 *      <div> Red roses too </div>
 *    )}
 *    case2='BLUE' then2={()=>(
 *      <div> I see them bloom </div>
 *    )}
 *    else={()=>(
 *      <div> For me and you </div>
 *    )}
 *  />
 */


exports.If = If;

var Case = function Case(props) {
  var val = props["switch"];

  for (var i = 0; i < 999; ++i) {
    if (props["case" + i] === undefined) {
      return instance(props["else"]);
    }

    if (props["case" + i] === val) {
      return instance(props["then" + i]);
    }
  }

  return null;
};

exports.Case = Case;